export default "/_next/static/chunks/fonts/Roboto Bold-75371f53f06181df75f16f2a140533e5.ttf";